import {createContext, FC, ReactNode, useContext, useState} from 'react'

type FilterOption = {value: string | number; label: string}

const useFilterState = () => {
  const [selectedEntities, setSelectedEntities] = useState<FilterOption[]>([])
  const [typeFilter, setTypeFilter] = useState('all')
  const [activeCategory, setActiveCategory] = useState<string | number | null>(null)
  const [permissionQuery, setPermissionQuery] = useState('')
  const [featureQuery, setFeatureQuery] = useState('')
  const [accessFilter, setAccessFilter] = useState('all')

  return {
    selectedEntities,
    setSelectedEntities,
    typeFilter,
    setTypeFilter,
    activeCategory,
    setActiveCategory,
    permissionQuery,
    setPermissionQuery,
    featureQuery,
    setFeatureQuery,
    accessFilter,
    setAccessFilter,
  }
}

const AccessMatrixFiltersContext = createContext<ReturnType<typeof useFilterState> | undefined>(
  undefined
)

export const AccessMatrixFiltersProvider: FC<{children: ReactNode}> = ({children}) => {
  const filters = useFilterState()

  return (
    <AccessMatrixFiltersContext.Provider value={filters}>
      {children}
    </AccessMatrixFiltersContext.Provider>
  )
}

export const useAccessMatrixFilters = () => {
  const filters = useContext(AccessMatrixFiltersContext)
  if (!filters) {
    throw new Error('useAccessMatrixFilters deve ser usado dentro de AccessMatrixFiltersProvider')
  }
  return filters
}
